import { TFunction } from "i18next";

import { DeviceTestResult } from "../../results-view/ResultsView.types";
import { DeviceStatus } from "../../results-view/ResultsView.types";
import { DeviceStatusDetail } from "../DeviceStatusDialogBox.types";

export const getTestResultStatus = (
  testResult: DeviceTestResult | undefined,
  deviceNameString: string,
  isMobile: boolean,
  t: TFunction
): {
  statusView: DeviceStatusDetail;
} => {
  let detailHeader = t("TEST_RESULT_STATUS_UNTESTED_HEADER", {
    deviceName: deviceNameString,
  });

  let detail =
    testResult?.detail ??
    t("TEST_RESULT_STATUS_UNTESTED_DETAIL", {
      deviceName: deviceNameString,
    });

  switch (testResult?.status) {
    case DeviceStatus.WORKING:
      detailHeader = t("TEST_RESULT_STATUS_WORKING_HEADER", {
        deviceName: deviceNameString,
      });
      detail = isMobile ? "" : t("TEST_RESULT_STATUS_WORKING_DETAIL");
      break;
    case DeviceStatus.FAILED:
      detailHeader = t("TEST_RESULT_STATUS_FAILED_HEADER", {
        deviceName: deviceNameString,
      });
      detail = t("TEST_RESULT_STATUS_FAILED_DETAIL");
      break;
    case DeviceStatus.MISSING:
      detailHeader = t("TEST_RESULT_STATUS_MISSING_HEADER", {
        deviceName: deviceNameString,
      });
      detail = t("TEST_RESULT_STATUS_MISSING_DETAIL", {
        deviceName: deviceNameString,
      });
      break;
    case DeviceStatus.UNAVAILABLE:
      detailHeader = t("TEST_RESULT_STATUS_UNAVAILABLE_HEADER", {
        deviceName: deviceNameString,
      });
      detail = t("TEST_RESULT_STATUS_UNAVAILABLE_DETAIL");
      break;
    case DeviceStatus.UNTESTED:
      detailHeader = detailHeader = t("TEST_RESULT_STATUS_UNTESTED_HEADER", {
        deviceName: deviceNameString,
      });
      detail = t("TEST_RESULT_STATUS_UNTESTED_DETAIL", {
        deviceName: deviceNameString,
      });
      break;
  }

  // Shouldn't be a prompt for user to change the device for network
  if (
    deviceNameString === "NETWORK_TITLECASE" ||
    deviceNameString === "NETWORK_LOWERCASE"
  ) {
    detail = "";
  }

  return {
    statusView: {
      header: detailHeader,
      body: detail,
    },
  };
};
